import styled from 'styled-components';

export const ActivityContainer = styled('div')`
    width: 70%;
    margin-left: 200px;
`;
